import { MEDIA_SKELETON_ITEMS_COUNT } from "@/config/constants";

/**
 * Loading state component for media attachments
 * Displays a grid of skeleton items when media attachments are being loaded
 *
 * How it works:
 * 1. Renders a grid of skeleton items that mimic the appearance of media thumbnails
 * 2. Uses animation to indicate loading state
 * 3. Provides visual feedback that content is loading
 *
 * Key features:
 * - Animated skeleton UI for better user experience
 * - Grid layout matching the actual media grid (2 columns on mobile, 3 on larger screens)
 * - Consistent styling with actual media items
 * - Clear visual indication of loading state
 */
export default function MediaAttachmentLoading() {
  // Create an array of 9 skeleton items (3x3 grid)
  const skeletonItems = Array.from(
    { length: MEDIA_SKELETON_ITEMS_COUNT },
    (_, index) => (
      <div
        key={index}
        className="aspect-square w-full animate-pulse overflow-hidden rounded-md bg-muted"
      />
    ),
  );

  return (
    <div className="w-full">
      <div className="grid grid-cols-3 gap-1 pt-1">{skeletonItems}</div>
    </div>
  );
}
